import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import { IInfoWidget } from '../shared/IInfoWidget';

export const useInfoWidgetService = () => {
  const customFetch = useCustomFetch();

  const fetchInfoWidgets = useCallback(async ({ signal }: ISignal) => {
    const [widgets] = await customFetch<IInfoWidget[]>("/json/infowidgets", { signal });
    return widgets || [];
  }, [customFetch]);

  const fetchInfoWidget = useCallback(async (id: string, { signal }: ISignal) => {
    const [widget] = await customFetch<IInfoWidget>(`/json/infowidgets?id=${id}`, {
      signal
    });
    return widget;
  }, [customFetch]);

  const saveInfoWidget = useCallback(async (data: IInfoWidget) => {
    const [widget] = await customFetch<IInfoWidget>("/json/infowidgets/add", {
      method: "POST",
      body: JSON.stringify(data),
    });
    return widget;
  }, [customFetch]);

  const saveInfoWidgets = useCallback(async (widgets: IInfoWidget[]) => {
    const [savedWidgets] = await customFetch<IInfoWidget[]>("/json/infowidgets/add", {
      method: "POST",
      body: JSON.stringify({ widgets }),
    });
    return savedWidgets;
  }, [customFetch]);

  const deleteInfoWidget = useCallback(async (id: string) => {
    await customFetch<void>("/json/infowidgets/delete", {
      method: "POST",
      body: JSON.stringify({ id }),
    });
    return true;
  }, [customFetch]);

  return { fetchInfoWidgets, fetchInfoWidget, saveInfoWidget, saveInfoWidgets, deleteInfoWidget };
}
